import { render, staticRenderFns } from "./ReviewRating.vue?vue&type=template&id=93647dc8&scoped=true&"
import script from "./ReviewRating.vue?vue&type=script&lang=js&"
export * from "./ReviewRating.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRating.vue?vue&type=style&index=0&id=93647dc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93647dc8",
  null
  
)

export default component.exports